import { debounce } from '../helpers/debounce';

const positionImages = () => {
  const partnershipImgs = document.querySelectorAll('.partnerships-list-item__image');
  const partnershipListLinks = document.querySelectorAll('.partnerships-list-item a');
  const minWidth = 50;

  function imagePosition() {
    const header = document.querySelector('.header');
    const minHeight = header.offsetHeight;

    partnershipImgs.forEach((image) => {
      const img = image.querySelector('img');
      const imgRect = img.getBoundingClientRect();
      const imgHeight = imgRect.height;
      const imgWidth = imgRect.width;
      const bodyHeight = window.innerHeight - imgHeight - minHeight;
      const bodyWidth = window.innerWidth - imgWidth - minWidth;
      const posY = Math.floor(Math.random() * (bodyHeight + 1)) + minHeight;
      const posX = Math.floor(Math.random() * (bodyWidth + 1)) + minWidth;

      Object.assign(image.style, {
        top: posY + 'px',
        left: posX + 'px',
      });
    });
  }

  if (!('ontouchstart' in document.documentElement)) {
    if (partnershipListLinks) {
      partnershipListLinks.forEach((partner) => {
        partner.addEventListener('mousemove', (e) => {
          const activeTitle = document.querySelector('.active-title');
          if (activeTitle) {
            activeTitle.classList.remove('active-title');
          }

          e.currentTarget.classList.add('active-title');
        });

        document.addEventListener('scroll', () => {
          const activeTitle = document.querySelector('.active-title');

          if (activeTitle) {
            activeTitle.classList.remove('active-title');
          }
        });
      });
    }
  }

  if (partnershipImgs) {
    imagePosition();

    window.addEventListener('resize', debounce(imagePosition));
  }
};

export default positionImages;
